import { CODES, extension } from './constants'
import * as R from 'ramda'

export const normalizeCode = (code) => {
  for (let i = 0; i < CODES.length; i++) {
    if (CODES[i].code == code) {
      return CODES[i].description
    }
  }
  return CODES[0].description
}

export const normalizeExtension = (list) => {
  for (let i = 0; i < list.length; i++) {
    list[i] =  extension.concat(list[i])
  }
  return list.join()
}

export const getUserName = (identities) => {
  let res = null
  for (let i = 0; i < identities.length; i++) {
    if (identities[i].signInType === "userName") {
      res = identities[i].issuerAssignedId
      return res
    }
  }
  return res
}

export const parseExtension = (obj, list) => {
  // Example inputs:
  // - obj = {surname: "Doe"}
  // - list = {UNDPMail: "doe@undp.org"}
  // Related output:
  // - {surname: "Doe", extension_UNDPMail: "doe@undp.org"}
  Object.keys(list).map((key, index) => {
    obj[extension.concat(key)] = list[key]
  })
  return obj
}

export const handleUndefined = (field) => {
  let res = field ? field : ''
  return res;
}

export const validateEmail = (email) => {
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

const rules = {
  numeric: { min: 1, max: 3 },
  uppercase: { min: 1, max: 3 },
  lowercase: { min: 1, max: 3 },
  general: function () {
    return { min: this.numeric.max + this.uppercase.max + this.lowercase.max, max: 2 * (this.numeric.max + this.uppercase.max + this.lowercase.max) }
  } 
}

export const randomPassword = () => {
  const chars = {
    numeric: '0123456789',
    uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    lowercase: 'abcdefghijklmnopqrstuvwxyz',
    general: function () {
      return this.numeric + this.uppercase + this.lowercase
    }
  }
  const length = {
    numeric: Math.floor(Math.random() * (rules.numeric.max + 1 - rules.numeric.min)) + rules.numeric.min,
    uppercase: Math.floor(Math.random() * (rules.uppercase.max + 1 - rules.uppercase.min)) + rules.uppercase.min,
    lowercase: Math.floor(Math.random() * (rules.lowercase.max + 1 - rules.lowercase.min)) + rules.lowercase.min,
    general: Math.floor(Math.random() * (rules.general().max + 1 - rules.general().min)) + rules.general().min,
  }
  let password = ''
  for (let i = 0; i < length.numeric; i++) {
    password += chars.numeric.charAt(Math.random() * chars.numeric.length)
  }
  for (let i = 0; i < length.uppercase; i++) {
    password += chars.uppercase.charAt(Math.random() * chars.uppercase.length)
  }
  for (let i = 0; i < length.lowercase; i++) {
    password += chars.lowercase.charAt(Math.random() * chars.lowercase.length)
  }
  for (let i = 0; i < length.general - length.numeric - length.uppercase - length.lowercase; i++) {
    password += chars.general().charAt(Math.random() * chars.general().length)
  }
  let shuffled = password.split('').sort(()=>(Math.random()-0.5)).join('')
  return shuffled
}

export const validatePassword = (password) => {
  return /[a-z]/.test(password) && /[A-Z]/.test(password) && /\d/.test(password) && (password.length >= rules.general().min)
}

export const checkAccessAllowed = (role,moreInfo = {}) => {
  //Allowed Roles ['PSSupport','GSDReadOnLy']
  switch (role){
    case 'PSSupport':
      return true;
    case 'GSDReadOnLy':
      return false;
    default:
      return false
  }
}
// extension_afc19e650ec54fbdbab16666a6342cd8_pwneverexpires